<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">" {{ editedEntity.department.name | translate }} - {{ editedEntity.process.name | translate }} " {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <filter-select
        class="mt-4"
        id="department-process-department-filter"
        ref="department-process-department-filter"
        :placeholder="$t('department.select')"
        :multiple="true"
        :displayCount="3"
        :isValid="!$v.form.department.$invalid"
        @filter="onDepartmentSearch"
        :selected="form.department"
        @changed="departmentSelect"
        track="_id"
      />
      <filter-select
        class="mt-4"
        id="processFilter"
        ref="processFilter"
        :placeholder="$t('process.select')"
        :multiple="true"
        :displayCount="3"
        :isValid="!$v.form.process.$invalid"
        @filter="onProcessSearch"
        :selected="form.process"
        @changed="processSelect"
        track="_id"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "departmentProcess";

export default {
  props: ["state"],
  data() {
    return {
      form: { department: undefined, process: undefined },
    };
  },
  validations: {
    form: {
      department: {
        required,
      },
      process: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceDepartmentProcess";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {
    this.state = this.state || state;
  },
  methods: {
    async save() {
      const departments = this.form.department;
      const childProcesses = this.form.process;
      this.$emit("onSave", departments, childProcesses);
    },

    async onDepartmentSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDepartment" : "managementDepartment";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout ? { "scope.value": { value: "system", isObject: true } } : {}) },
      });
      callback(response.data?.docs ?? []);
    },
    departmentSelect(item) {
      this.form = { ...this.form, department: item };
    },
    async onProcessSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceProcess" : "managementProcess";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout ? { "scope.value": { value: "system", isObject: true } } : {}) },
      });
      callback(response.data?.docs ?? []);
    },
    processSelect(item) {
      this.form = { ...this.form, process: item };
    },
  },
};
</script>
